export const breakpoints = {
  xs: '0em', // 0px
  sm: '37.5em', // 600px
  md: '56.5625em', // ~904px
  lg: '77.5em', // 1240px
  xl: '90em', // 1440px
};
